import React, { useCallback, useState } from 'react';
import { useStravaTranslations } from '@strava/container-context';
import clsx from '@strava/ui/clsx';
import CPRAComplianceModal from './components/CPRAComplianceModal';

import styles from './CPRAComplianceCTA.module.scss';

export interface CPRAComplianceCTAProps {
  isLoggedIn?: boolean;
  className?: string;
  i18nPrefix?: string;
  dataSharingOptedOut?: boolean;
}

const CPRAComplianceCTA = ({
  isLoggedIn = false,
  className = '',
  i18nPrefix = '',
  dataSharingOptedOut
}: CPRAComplianceCTAProps) => {
  const [showModal, setShowModal] = useState(false);

  const { t: _t } = useStravaTranslations();

  const t = useCallback(
    (
      key: string,
      params?: Record<string, string | number | undefined | null>
    ) => _t(`${i18nPrefix}.cpra_compliance_cta.${key}`, { ...params }),
    [_t, i18nPrefix]
  );

  return (
    <>
      <button
        id="cpra-compliance-cta"
        className={clsx(styles.cpraButton, className)}
        onClick={() => setShowModal(true)}
      >
        {t('cta')}
      </button>
      {showModal && (
        <CPRAComplianceModal
          onDismiss={() => setShowModal(false)}
          isLoggedIn={isLoggedIn}
          t={t}
          dataSharingOptedOut={dataSharingOptedOut}
        />
      )}
    </>
  );
};

export default CPRAComplianceCTA;
